<template>
  <v-main class="page-library page-library-search">
    <AppBar extension-height="60px" title="검색" :back="customBack">
      <div class="library-search-area">
        <v-form @submit.prevent="onSubmit(searchKeyword)">
          <v-text-field outlined flat solo
                        hide-details
                        ref="searchKeyword"
                        :search-keywords="keywords"
                        v-model.trim="searchKeyword"
                        :placeholder="placeholder"
                        @input="onChange"
                        @focus="onFocus"
                        @blur="onBlur"
          >
            <template #prepend-inner>
              <v-btn type="submit" text plain icon>
                <img :src="getImage('ic_search.svg')" alt="검색" />
              </v-btn>
            </template>
          </v-text-field>
        </v-form>
<!--        <div class="search-input-group" @click="onFocusArea">-->
<!--          <v-btn icon large class="search-icon" @click="onSearch">-->
<!--            <img :src="getImage('ic_search.svg')" alt="검색" />-->
<!--          </v-btn>-->
<!--          <input type="text"-->
<!--                 class="search-input"-->
<!--                 :placeholder="searchPlaceHolder"-->
<!--                 v-model="searchText"-->
<!--                 @keydown="onSearch($event)"/>-->
<!--        </div>-->
      </div>
    </AppBar>
    <keep-alive >
      <component :is="currentView" :category="category" @onEvent="onEvent" />
    </keep-alive>
  </v-main>
</template>
<script>
import SearchMain from './LibrarySearchMain'
import SearchKeyword from './LibrarySearchBody'
// import SearchResult from './LibrarySearchResultNew'
import SearchResult from './LibrarySearchDetailsNew.vue'
import SearchDetails from './LibrarySearchDetails.vue'
import store from "@/store";

export default {
  name: 'LibrarySearch',
  components: {
    SearchMain,
    SearchKeyword,
    SearchResult,
    SearchDetails
  },
  data: () => ({
    currentView: 'SearchMain',
    searchKeyword: null,
    category: []
  }),
  computed: {
    keywords () {
      return this.$store.state.library.libraryKeywords
    },
    placeholder () {
      return this.currentView === 'SearchMain' ? '검색해보세요.' : '검색어를 입력해주세요.'
    }
  },
  created() {
    this.getCodeList()
    let str = this.$route.query.search
    if (str) {
      this.searchKeyword = str
      this.currentView = 'SearchResult'
    }
  },
  methods: {
    onEvent (value) {
      this[value.fn](value.params)
    },
    onChange () {
      this.currentView = 'SearchKeyword'
    },
    onFocus () {
      if (this.searchKeyword === null) {
        this.currentView = 'SearchKeyword'
      }
    },
    onBlur () {},
    onSubmit (keyword) {
      this.searchKeyword = keyword
      let str = keyword
      if (!str) return false
      this.setLibraryKeywords(str)
      this.currentView = 'SearchResult'
      this.$router.replace({ path: this.$route.path, query: { search: str } }).catch(() => {})
    },
    customBack() {
      if (this.currentView === 'SearchMain') {
        this.prevPage()
      } else if (this.currentView === 'SearchDetails') {
        this.$router.back()
        this.currentView = 'SearchResult'
      } else {
        this.searchKeyword = null
        this.currentView = 'SearchMain'
        this.$router.replace(this.$route.path).catch(() => {})
      }
    },
    setLibraryKeywords (keyword) {
      this.$store.commit('setLibraryKeywords', keyword)
    },
    setView (value) {
      console.log('얍')
      this.currentView = value
    },
    async getCodeList(cdGrp = 'LB002') {
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': cdGrp}))
        .then(res => {
          if (res.success) {
            this.category = res.data
          } else {
            this.category = []
          }
        })
        .catch(() => {
          this.category = []
        })
        .finally(() => {})
    }
  }
}
</script>
